import { ESP } from "../tema";
import { ESTILO_CAMPO, Rotulo } from "./Campo";

export default function Sel({ label, value, onChange, options, style = {} }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: ESP.xs, ...style }}>
      {label && <Rotulo>{label}</Rotulo>}
      <select value={value} onChange={e => onChange(e.target.value)}
        style={{ ...ESTILO_CAMPO, cursor: "pointer" }}>
        {options.map(o => (
          <option key={typeof o === "string" ? o : o.value} value={typeof o === "string" ? o : o.value}>
            {typeof o === "string" ? o : o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
